import firebase from "firebase/app"
import "firebase/auth"

export const auth = firebase.initializeApp({
  apiKey: "AIzaSyBVQNsVfrc132dreSm2uRFTdmnNOSYe3pI",
    authDomain: "wechat-863d7.firebaseapp.com",
    projectId: "wechat-863d7",
    storageBucket: "wechat-863d7.appspot.com",
    messagingSenderId: "504732007336",
    appId: "1:504732007336:web:a775269fc195aadef93b9d"
}).auth()
